import { Outlet } from "react-router-dom";
import { Stack, styled } from "@mui/material";

export const LearnerLayout = () => {
  return (
    <LearnerLayoutWrapper>
      <Outlet />
    </LearnerLayoutWrapper>
  );
};

const LearnerLayoutWrapper = styled(Stack)`
  width: 1198px;
  margin: 0 auto;
`;
